"use client";

import DOMPurify from "dompurify";

import { MentionText } from "@/components/MentionInput";
import { looksLikeHtml, preserveEmptyParagraphs } from "@/lib/job-posting-html";
import { linkifyHashtagHtml } from "@/lib/hashtag-links";
import { linkifyMentionHtml } from "@/lib/mentions";
import { RICH_TEXT_TAGS } from "@/lib/rich-text-format";
import { cn } from "@/lib/utils";

const PURIFY = {
  ALLOWED_TAGS: [...RICH_TEXT_TAGS],
  ALLOWED_ATTR: ["style", "href", "target", "rel", "class"],
};

export function FormattedBody({
  html,
  className,
}: {
  html: string;
  className?: string;
}) {
  if (!html) return null;
  if (!looksLikeHtml(html)) {
    return <MentionText text={html} className={cn("whitespace-pre-wrap", className)} />;
  }

  const clean = linkifyHashtagHtml(
    linkifyMentionHtml(DOMPurify.sanitize(preserveEmptyParagraphs(html), PURIFY)),
  );
  return (
    <div
      className={cn(
        "rich-text-body",
        className,
      )}
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}
